import { BrowserRouter as Link} from 'react-router-dom';
import logo from '../../images/logo.png';
import './style.css';

export default function Footer(){
    return(
        <div className='footerContainer'>
           <ul>
                <li>앤츠네스트 | 대표자: 용수현</li>
                <li>| 서울시 강남구 도곡로3길 13(르-메이에르 타운)206-1호</li>
                <li>| 전화번호 : 070-7797-0814 |이메일: admin@antsnest.co.kr</li>
                <li>| &copy;ANTSNEST DEVELOPER CENTER Co.Ltd.All Rights Reserved.</li>
           </ul>
        </div>
    );
}